<template>
  <TagsViewer
    :editMode="true"
    :filterByTag="userEditObj.tags"
    :tags="Object.values(deluge.tags)"
    @select="add_tag_to_select"
    @newTag="on_new_tag"
    :selectable="true"
    :showAddButton="true"
    :tagContainerHeight="true" />
</template>
<script setup>
import { defineProps } from 'vue';
import TagsViewer from '../../Shared/TagsViewer.vue';
import { deluge } from '../../../stores/deluge';

const props = defineProps(['userEditObj']);
function add_tag_to_select(newTag) {
  if (!props.userEditObj.tags.includes(newTag.uid)) {
    props.userEditObj.tags.push(newTag.uid);
  } else {
    props.userEditObj.tags = props.userEditObj.tags.filter(
      (tag) => tag !== newTag.uid
    );
  }
}

// Auto-select newly created tags
function on_new_tag(newTagObj) {
  if (newTagObj?.uid && !props.userEditObj.tags.includes(newTagObj.uid)) {
    props.userEditObj.tags.push(newTagObj.uid);
  }
}
</script>

<style scoped></style>
